"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.aiFormAnalyzer.name': 'AI 表单分析器',
    'tools.aiFormAnalyzer.formSentByUser': '我已提交表单。',
};
